import { gql } from "@apollo/client";

export const selectFBWayForCreateFlyer = gql`
  mutation selectFBWayForCreateFlyer($campaignId: ID!) {
    selectFBWayForCreateFlyer(campaignId: $campaignId) {
      id
    }
  }
`;
